module.exports = __webpack_public_path__ + "static/media/tip_text_dog_chewable_en.a7de18bd.svg";